import { RootState } from '../store'
import { toasterMessages } from './reducer'

export const getToasterMessages = (state: RootState) =>
  toasterMessages.getSelectors().selectAll(state.toaster)
